import { useEffect } from "react";
import { Modal, Form, Input, Select, message } from "antd";
import {
  PostCase,
  createPostCase,
  updatePostCase,
} from "../../../api/postCaseAPI";

interface Props {
  open: boolean;
  postId: number;
  editingCase: PostCase | null;   // null 이면 생성 모드
  nextListOrder: number;          // 생성 시 사용할 listOrder
  onClose: () => void;
  onSuccess: () => void;          // 부모에서 case 목록 갱신
}

interface FormValues {
  name?: string;
  organ?: string;
  note?: string;
  gender?: string;
  age?: string;
}

const PostCaseModal = ({
  open,
  postId,
  editingCase,
  nextListOrder,
  onClose,
  onSuccess,
}: Props) => {
  const [form] = Form.useForm<FormValues>();
  const isEdit = !!editingCase;

  useEffect(() => {
    if (open) {
      if (editingCase) {
        form.setFieldsValue({
          name: editingCase.name,
          organ: editingCase.organ,
          note: editingCase.note,
          gender: editingCase.gender,
          age: editingCase.age,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, editingCase]);

  const handleSubmit = async (values: FormValues) => {
    if (isEdit && editingCase) {
      const result = await updatePostCase({
        postCaseId: editingCase.postCaseId,
        name: values.name,
        organ: values.organ,
        note: values.note,
        gender: values.gender,
        age: values.age,
      });
      if (result.success) {
        message.success("케이스가 수정되었습니다.");
        onSuccess();
        onClose();
      } else {
        message.error(result.message);
      }
    } else {
      const result = await createPostCase({
        postId,
        name: values.name,
        organ: values.organ,
        note: values.note,
        gender: values.gender,
        age: values.age,
        listOrder: nextListOrder,
      });
      if (result.success) {
        message.success("케이스가 등록되었습니다.");
        onSuccess();
        onClose();
      } else {
        message.error(result.message);
      }
    }
  };

  return (
    <Modal
      open={open}
      title={isEdit ? "Case 수정" : "Case 추가"}
      onCancel={onClose}
      onOk={() => form.submit()}
      okText={isEdit ? "수정" : "등록"}
      cancelText="취소"
      destroyOnClose
      centered
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="name" label="Name">
          <Input placeholder="비워두면 Case 1, Case 2 … 로 표시됩니다" />
        </Form.Item>
        <Form.Item name="organ" label="Organ">
          <Input />
        </Form.Item>
        <div style={{ display: "flex", gap: "1rem" }}>
          <Form.Item name="gender" label="Gender" style={{ flex: 1 }}>
            <Select allowClear placeholder="선택">
              <Select.Option value="M">Male</Select.Option>
              <Select.Option value="F">Female</Select.Option>
              <Select.Option value="U">Unknown</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name="age" label="Age" style={{ flex: 1 }}>
            <Input />
          </Form.Item>
        </div>
        <Form.Item name="note" label="Note">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PostCaseModal;